'use client';

/**
 * 500 / global error page — UI-SPEC §6 surface 6 + §8 copy.
 * Sentry/GlitchTip integration is deferred to Phase 1.5 (per Marx 2026-05-27);
 * for now we console.error so the issue surfaces in browser dev tools.
 *
 * Plan 01-04 Task 4.
 */
import { useEffect } from 'react';

import { Button } from '@/ui/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/ui/components/ui/card';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Phase-1.5 (Plan 015-01) swaps this for a real error-tracker call;
    // for now we log to console + journalctl (Phase 1.5 deploys journalctl).
    console.error('[remos] unhandled error', { digest: error.digest, message: error.message });
  }, [error]);

  return (
    <main className="bg-background text-foreground flex min-h-screen flex-col items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <Card>
          <CardHeader>
            <CardTitle>Ein technischer Fehler ist aufgetreten.</CardTitle>
            <CardDescription>
              Wir wurden automatisch informiert. Bitte versuchen Sie es in einigen Minuten erneut.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            {/* Version-Skew (Lara-R2): nach einem Deploy schlagen Server Actions
                aus stale Tabs fehl ("Failed to find Server Action") und landen
                hier als generischer Digest-Fehler. reset() rendert nur neu und
                behält den stale Client-Bundle — erst ein echter Reload holt den
                neuen Build. */}
            <p className="text-muted-foreground text-sm">
              Möglicherweise wurde REMOS gerade aktualisiert — bitte Seite neu laden.
            </p>
            <Button onClick={() => window.location.reload()} className="w-full">
              Seite neu laden
            </Button>
            <Button variant="outline" onClick={reset} className="w-full">
              Erneut versuchen
            </Button>
          </CardContent>
        </Card>
      </div>
    </main>
  );
}
